module.exports = __webpack_public_path__ + "img/Rocket.9f8255b1.svg";